import { faMinus, faPlus, faSave } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useDrawingManager } from "./useDrawingManager";
import { useState } from "react";
import { AssignArea } from "./AssignArea";

export const DrawArea = ({ refetchArea }: { refetchArea: any }) => {
  const { setShow, show, overlay, polygon } = useDrawingManager();
  const [showDialog, setShowDialog] = useState(false);
  return (
    <>
      <div className="absolute bottom-12 w-full flex gap-x-3 justify-center right-60">
        {show ? (
          <>
            <div>
              <button
                className="btn btn-primary px-3 py-1 btn-rounded icon shadow add-listing  z-20 relative"
                onClick={() => setShowDialog(true)}
              >
                <FontAwesomeIcon icon={faSave} />
                <span> Assign</span>
              </button>
            </div>

            <div>
              <button
                className="btn btn-primary px-3 py-1 btn-rounded icon shadow add-listing  z-20 relative"
                onClick={() => {
                  setShow(false);
                  overlay?.setMap(null);
                }}
              >
                <FontAwesomeIcon icon={faMinus} />
                <span> Close</span>
              </button>
            </div>
          </>
        ) : (
          <button
            onClick={() => setShow(true)}
            className="btn btn-primary px-3 py-1 btn-rounded icon shadow add-listing z-20 relative"
          >
            <FontAwesomeIcon icon={faPlus} />
            <span> Draw Area</span>
          </button>
        )}
      </div>

      {showDialog && polygon && (
        <AssignArea
          handleClose={() => {
            setShowDialog(false);
            refetchArea();
          }}
          path={polygon}
        />
      )}
    </>
  );
};
